// External
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

/* Ott-common */
import { assetTypes } from '@dtvgo/rtk-query-api';

// Components
import AgeRating from '../../ageRating/AgeRating';
import Metadata from '../../../pdp/metadata/Metadata';

// Styles
import './DetailsTab.scss';

// Other
import SkeletonBox from '../../skeletonBox/SkeletonBox';

function DetailsTab({
  asset, duration, isLoading, intl: { formatMessage },
}) {
  const {
    title = '',
    description = '',
    genres = [],
    live = {},
    rating = '',
    ratingWarning = [],
    ratingDescription = '',
  } = asset;

  const {
    channelName,
  } = live || {};

  let isLiveContent = false;
  let content;

  switch (asset?.type) {
    case assetTypes.movie:
    case assetTypes.liveMovie:
      content = formatMessage({ id: 'movie.details.about', defaultMessage: 'Acerca de esta película' });
      break;
    case assetTypes.serie:
    case assetTypes.episode:
    case assetTypes.liveEpisode:
    case assetTypes.liveSerie:
      content = formatMessage({ id: 'serie.details.about', defaultMessage: 'Acerca de esta serie' });
      break;
    case assetTypes.channel:
    case assetTypes.liveShow:
    case assetTypes.liveSport:
    case assetTypes.show:
    case assetTypes.sport:
      content = formatMessage({ id: 'live.details.about', defaultMessage: 'Acerca de este contenido en vivo' });
      isLiveContent = true;
      break;
    default:
      content = formatMessage({ id: 'serie.details.about', defaultMessage: 'Acerca de esta serie' });
      break;
  }

  return (
    <div className="dtv-details-tab">

      <section className="dtv-details-tab__asset-info">
        {isLoading ? (
          <div className="dtv-details-tab__about-loading">
            <SkeletonBox />
            <SkeletonBox />
            <SkeletonBox />
          </div>
        ) : (
          <>
            <h5 className="dtv-details-tab__about">
              {content}
            </h5>
            <h1 className="dtv-details-tab__title">{title}</h1>
            <p className="dtv-details-tab__description">{description}</p>
          </>
        )}

      </section>

      {isLoading ? (
        <div className="dtv-details-tab__genre-rating-loading">
          <SkeletonBox />
        </div>
      ) : (
        <section className="dtv-details-tab__genre-rating" style={{ display: genres.length > 0 ? 'flex' : 'none' }}>
          <section className="dtv-details-tab__labels-section">
            {duration && (
              <div className="dtv-details-tab__labels-section-item">
                <h4 className="dtv-details-tab__duration-label">
                  {formatMessage({ id: 'serie.details.duration', defaultMessage: 'Duración' })}
                </h4>
                <span className="dtv-details-tab__duration-value">{duration}</span>
              </div>
            )}

            {isLiveContent && channelName && (
              <div className="dtv-details-tab__labels-section-item">
                <h4 className="dtv-details-tab__duration-label">
                  {formatMessage({ id: 'serie.details.channel', defaultMessage: 'Canal' })}
                </h4>
                <span className="dtv-details-tab__duration-value">{channelName}</span>
              </div>
            )}

            <div className="dtv-details-tab__labels-section-item">
              <h4 className="dtv-details-tab__genre-label">
                {formatMessage({ id: 'serie.details.genre', defaultMessage: 'Género' })}
              </h4>
              <ul className="dtv-details-tab__genre-list">
                <Metadata metadataValues={genres.slice(0, 3)} />
              </ul>
            </div>

            {rating && (
              <div className="dtv-details-tab__labels-section-item">
                <h4 className="dtv-details-tab__rating-label">
                  {formatMessage({ id: 'serie.details.rating', defaultMessage: 'Clasificación' })}
                </h4>
                <div className="dtv-details-tab__rating-info">
                  <AgeRating rating={rating} />
                  <div>
                    <p className="dtv-details-tab__rating-description">{ratingDescription}</p>
                    {ratingWarning.length > 0 && <p className="dtv-details-tab__rating-warning">{ratingWarning?.join(', ')}</p>}
                  </div>
                </div>
              </div>
            )}
          </section>
        </section>
      )}
    </div>
  );
}

DetailsTab.propTypes = {
  asset: PropTypes.shape().isRequired,
  duration: PropTypes.string,
  isLoading: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

DetailsTab.defaultProps = {
  duration: '',
  isLoading: false,
};

export default injectIntl(DetailsTab);
